import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { FinishTutorialRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { FinishTutorialResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const finishTutorial = (request: FinishTutorialRequest, options?: CashRequestOptions) =>
  post<FinishTutorialRequest, FinishTutorialResponse>('/2.0/cash/finish-tutorial', request, {
    ...options,
    rejectOnError: true,
  })
